import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import getNumberOfLayers from "../../../../service/getNumberOfLayers"
import type EstimateValues from "../../../../types/params"

const replaceBuildUpMethod = (values: EstimateValues) => {
  const isDisplayed = getDisplayCondition(values)
  const numberOfLayers = getNumberOfLayers(values)

  if (isDisplayed.buildUpMethod) {
    switch (values.buildUpMethod) {
      case ESTIMATE_CONSTANT.ビルドアップ工法["なし(4層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["なし(6層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["なし(8層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["なし(10層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["なし(12層)"].value:
        if (numberOfLayers === 4) return ESTIMATE_CONSTANT.ビルドアップ工法["なし(4層)"].value
        if (numberOfLayers === 6) return ESTIMATE_CONSTANT.ビルドアップ工法["なし(6層)"].value
        if (numberOfLayers === 8) return ESTIMATE_CONSTANT.ビルドアップ工法["なし(8層)"].value
        if (numberOfLayers === 10) return ESTIMATE_CONSTANT.ビルドアップ工法["なし(10層)"].value
        if (numberOfLayers === 12) return ESTIMATE_CONSTANT.ビルドアップ工法["なし(12層)"].value
        break

      case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(4層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(6層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(8層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(10層)"].value:
      case ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(12層)"].value:
        if (numberOfLayers === 4) return ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(4層)"].value
        if (numberOfLayers === 6) return ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(6層)"].value
        if (numberOfLayers === 8) return ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(8層)"].value
        if (numberOfLayers === 10) return ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(10層)"].value
        if (numberOfLayers === 12) return ESTIMATE_CONSTANT.ビルドアップ工法["その他の構成(12層)"].value
        break
    }
  }

  return values.buildUpMethod
}

export default replaceBuildUpMethod
